__turbopack_context__.v({
  "link": "gdprMessage-module-scss-module__HtDpfW__link",
});
